import get from "lodash/get"
import {
  GET_LOCATIONS_PENDING,
  GET_FACILITY_ALERTS_FULFILLED,
  GET_LOCATIONS_FULFILLED,
  GET_LOCATIONS_REJECTED,
  SET_HAS_GEOSUGGESTION,
  SET_SEARCH_TEXT,
  SET_CUSTOMER_ACTION,
  CLEAR_HOVERED_MAP_MARKER_ID,
  SET_HOVERED_MAP_MARKER_ID,
  CLEAR_SELECTED_FACILITY_ID,
  SELECT_FACILITY,
  UPDATE_GEOSUGGEST_LOCATION,
  TRANSLATE_FACILITY,
} from "constants-lib/actionTypes"

// Must be a pure function that requires the state
// and the action being dispatched.

const initialState = {
  error: null,
  fetched: false,
  fetching: false,
  hasLoadedLocations: false,
  hasGeosuggestion: true,
  localUrl: ``,
  mapLocations: [],
  hoveredMapMarkerId: null,
  searchText: ``,
  selectedCustomerAction: `drop_off_waste`,
  selectedGeosuggestion: null,
  selectedFacilityId: null,
  listItemSelected: false,
  translatedFacility: null,
  alerts: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATIONS_PENDING: {
      return {
        ...state,
        fetching: true,
        hasLoadedLocations: false,
      }
    }

    case GET_FACILITY_ALERTS_FULFILLED: {
      return {
        ...state,
        alerts: action.payload,
      }
    }

    case GET_LOCATIONS_FULFILLED: {
      const { localizedContent, facilityLocations } = action.payload

      /* Localized content check. */
      const urls = get(localizedContent, `features`, []).filter(
        (u) => u.properties.LocalizeUrl !== ``,
      )
      let url = ``
      if (urls.length > 0) {
        url = urls[0].properties.LocalizeUrl
        if (url[0] === `/`) {
          url = `http://www.wmcanada.com${url}`
        }
      }

      return {
        ...state,
        // Localized content field:
        localUrl: url,
        // Facility search fields:
        selectedGeosuggestion: facilityLocations.features
          ? state.selectedGeosuggestion
          : null,
        fetching: false,
        fetched: true,
        hasLoadedLocations: true,
        mapLocations: facilityLocations.features,
        selectedFacilityId: null,
        hoveredMapMarkerId: null,
        listItemSelected: false,
      }
    }

    case GET_LOCATIONS_REJECTED:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case SET_HAS_GEOSUGGESTION:
      return {
        ...state,
        hasGeosuggestion: action.payload,
      }

    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      }

    case SET_CUSTOMER_ACTION:
      return {
        ...state,
        selectedFacilityId: null,
        selectedCustomerAction: action.payload,
      }

    case CLEAR_HOVERED_MAP_MARKER_ID:
      return {
        ...state,
        hoveredMapMarkerId: null,
      }

    case SET_HOVERED_MAP_MARKER_ID:
      return {
        ...state,
        hoveredMapMarkerId: action.payload,
      }

    case CLEAR_SELECTED_FACILITY_ID:
      return {
        ...state,
        hoveredMapMarkerId: null,
        selectedFacilityId: null,
        listItemSelected: false,
      }

    case SELECT_FACILITY:
      return {
        ...state,
        hoveredMapMarkerId: action.payload.hoveredMapMarkerId,
        selectedFacilityId: action.payload.selectedFacilityId,
        listItemSelected: action.payload.listItemSelected,
      }

    case UPDATE_GEOSUGGEST_LOCATION:
      return {
        ...state,
        selectedGeosuggestion: action.payload,
      }

    case TRANSLATE_FACILITY:
      return {
        ...state,
        translatedFacility: action.payload,
      }

    default:
      return state
  }
}
